module.exports = __webpack_public_path__ + "front/img/0_kv.9a753acc.png";